
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const prayerTimes = createApi({
  reducerPath: 'prayerTimes',
  baseQuery: createCustomFetchBaseQuery(),
  // Every prayer-time save changes what every table shows, so one tag for all.
  tagTypes: ['PrayerTimes'],
  endpoints: (builder) => ({

    getazantime: builder.query({
      query: ({  year, month }) => ({
        url: `/api/azantimes/${year}/${month}`,
        method: 'GET',
      
      }),
      providesTags: ['PrayerTimes'],
    }),
    
    // Athan times with unsaved calculation settings, worked out by the server
    // exactly as Save would.
    previewAzanTimes: builder.query({
      query: ({ year, month, calculationMethod, school, higherLatitudeMethod }) => ({
        url: `/api/azantimes/preview/${year}/${month}`,
        params: { calculationMethod, school, higherLatitudeMethod },
        method: 'GET',
      }),
    }),

    getiqamahtimes: builder.query({
        query: ({ year, month }) => ({
        url: `/api/iqamahtimes/get-iqamahtimes-delay/${year}/${month}`,
        method: 'GET',
      }),
      providesTags: ['PrayerTimes'],
    }),

    createAzanTime: builder.mutation({
      query: (data) => ({
        url: `/api/azantimes/create-azantime`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PrayerTimes'],
    }),

    updateiqamahdelay: builder.mutation({
      query: (data) => ({
        url: `/api/iqamahtimes/update-iqamahtimes-delay`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PrayerTimes'],
    }),

    // GET JUMMAH TIME
    getJummahtime: builder.query({
      query: () => ({
        url: `/api/jummahtimes/get-jummahtimes`,
        method: 'GET',
      }),
      providesTags: ['PrayerTimes'],
    }),

    createUpdateJummahTime: builder.mutation({
      query: (data) => ({
        url: `/api/jummahtimes/cu-jummahtimes`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PrayerTimes'],
    }),


      // GET JUMMAH TIME
      getSlahtime: builder.query({
        query: () => ({
          url: `/api/special-salah/get-special-salahtimes`,
          method: 'GET',
        }),
      providesTags: ['PrayerTimes'],
      }),
  
      createUpdateSlahTime: builder.mutation({
        query: (data) => ({
          url: `/api/special-salah/cu-special-salahtimes`,
          method: 'POST',
          body: data,
        }),
      invalidatesTags: ['PrayerTimes'],
      }),

      bulkPrayertimes: builder.query({
          query: ({  month ,  year, }) => ({
            url: `/api/bulk/get-bulk-prayer-times/${year}/${month}`,
            method: 'GET',
        }),
      providesTags: ['PrayerTimes'],
      }),

  }),
});

export const {
  useGetazantimeQuery,
  usePreviewAzanTimesQuery,
  useCreateAzanTimeMutation,
  useGetiqamahtimesQuery,
  useUpdateiqamahdelayMutation,
  useGetJummahtimeQuery,
  useCreateUpdateJummahTimeMutation,
  useGetSlahtimeQuery,
  useCreateUpdateSlahTimeMutation,
  useBulkPrayertimesQuery,
  useLazyBulkPrayertimesQuery
} = prayerTimes;